import { mount, unmount } from './mount';
import type { WidgetProps } from './Widget';

const AUTO_MOUNT_SELECTOR = '[data-webflow-widget]';
const MOUNTED_FLAG = 'webflowWidgetMounted';

const readProps = (el: HTMLElement): WidgetProps => {
  const { hubspotPortalId, hubspotFormId } = el.dataset;
  return {
    hubspotPortalId,
    hubspotFormId,
  };
};

// Auto-mount into every element tagged with data-webflow-widget. This lets a
// Webflow page embed the widget by dropping in a div plus the script tag, with
// no inline JavaScript required.
const autoMount = (): void => {
  document.querySelectorAll<HTMLElement>(AUTO_MOUNT_SELECTOR).forEach(el => {
    if (el.dataset[MOUNTED_FLAG] === 'true') {
      return;
    }
    el.dataset[MOUNTED_FLAG] = 'true';
    mount({ target: el, props: readProps(el) });
  });
};

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoMount);
  } else {
    autoMount();
  }
}

export { mount, unmount, autoMount };
export type { WidgetProps };
